
//import Vue from 'vue'
//import Cookie from './cookie.js'

let signalR = require('@aspnet/signalr')

export default {

    connection: null,

    connect(callback) {

        // estou pegando o id do usuário logado que foi setado no cookie
        //var _userId = Cookie.get("USER_ID");

        // tento inicializar a conexão com meu hub
        this.connection.start().then(() => {

            // no meu hub existe um método "SetUser(int userId)" que seta esse meu id de usuário num grupo especifico
            //this.connection.invoke("SetUser", _userId);

            // no meu hub quando o usuário clica em uma das ações "play" ou "pause" eu emito um evento para todos os clientes registrados com o id de usuário setado acima
            //this.connection.on("PlayPauseChange", action => {
            //    // quando chamado, eu emito um evento para todos os meus componentes que mudam os ícones de "play" e "pause" no sistema
            //    // esse método Vue.prototype.$eventHub.$emit é especifico do eventBus para o Vue 
            //    Vue.prototype.$eventHub.$emit('play-pause-change', action)
            //});

            this.connection.invoke('getConnectionId')
                .then(function (connectionId) {
                    document.notification_id = connectionId;
                }).catch(err => console.error(err.toString()));            

            callback();

        }, () => {
            // caso dê erro, o client continua tentando
            setTimeout(() => {
                this.connect()
            }, 2000);
        });

        // caso aconteça algum problema de conexão, o client tenta novamente
        this.connection.onclose(() => {
            this.connect();
        });

    },

    start(callback) {

        // configura a conexão com seu hub do signalr
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl('/notificationHub')
            .build();

        // por conta de problemas de tempo de execução, eu defino um settimeout de 1 segundo
        setTimeout(() => {
            this.connect(callback);
        }, 1000);
    }

};
